module.exports = __webpack_public_path__ + "files/371a232be3b4352ef79d7d3dfd084549.png";